module.exports = __webpack_public_path__ + "img/font.74070960.svg";